import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useMemo, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { resolveNestedPropClassNames } from "@jutro/uiconfig";
import { routesShape, contextSwitcherShape, sideContentShape } from "@jutro/prop-types";
import { BreakpointTrackerContext } from "@jutro/layout";
import { QuickViewProvider } from "@jutro/quick-view";
import { RightSideBarContext } from "@jutro/router";
import AppFloorPlanLayout from "./AppFloorPlanLayout";
import useFloorPlanMatch from "./useFloorPlanMatch";
import { AppFloorPlanContent } from "./AppFloorPlanContent";
import { AppFloorPlanFooter } from "./AppFloorPlanFooter";
import { AppFloorPlanRightSide } from "./AppFloorPlanRightSide";
import { AppFloorPlanLeftSide } from "./AppFloorPlanLeftSide";
import { AppFloorPlanSubHeader } from "./AppFloorPlanSubHeader";
import { AppFloorPlanHeader } from "./AppFloorPlanHeader";
export var AppFloorPlan = function (_ref) {
  var componentMap = _ref.componentMap,
    _ref$callbackMap = _ref.callbackMap,
    callbackMap = void 0 === _ref$callbackMap ? {} : _ref$callbackMap,
    _ref$classNameMap = _ref.classNameMap,
    classNameMap = void 0 === _ref$classNameMap ? {} : _ref$classNameMap,
    _ref$floorPlans = _ref.floorPlans,
    floorPlan = useFloorPlanMatch(void 0 === _ref$floorPlans ? [] : _ref$floorPlans),
    headerProps = floorPlan.header,
    rightSideProps = floorPlan.rightSide,
    subHeaderProps = floorPlan.subHeader,
    routes = floorPlan.routes,
    sideRoutes = floorPlan.sideRoutes,
    footerProps = floorPlan.footer,
    leftSideProps = floorPlan.leftSide,
    _floorPlan$scrollCont = floorPlan.scrollContent,
    scrollContent = void 0 === _floorPlan$scrollCont || _floorPlan$scrollCont,
    _floorPlan$showSubHea = floorPlan.showSubHeader,
    showSubHeaderProp = void 0 === _floorPlan$showSubHea || _floorPlan$showSubHea,
    _floorPlan$showHeader = floorPlan.showHeader,
    showHeader = void 0 === _floorPlan$showHeader || _floorPlan$showHeader,
    _floorPlan$showLeftSi = floorPlan.showLeftSide,
    showLeftSideProp = void 0 === _floorPlan$showLeftSi || _floorPlan$showLeftSi,
    _floorPlan$showRightS = floorPlan.showRightSide,
    showRightSideProp = void 0 === _floorPlan$showRightS || _floorPlan$showRightS,
    _floorPlan$showFooter = floorPlan.showFooter,
    showFooter = void 0 === _floorPlan$showFooter || _floorPlan$showFooter,
    renderHeader = floorPlan.renderHeader,
    contentLayout = floorPlan.contentLayout,
    contentClassName = floorPlan.contentClassName,
    contentAsSectionElement = floorPlan.contentAsSectionElement,
    className = cx(floorPlan.className),
    isLowerThanDesktop = "desktop" !== useContext(BreakpointTrackerContext),
    visibleRoutes = useMemo(function () {
      var _context, _context2;
      return _mapInstanceProperty(_context = _filterInstanceProperty(_context2 = routes || []).call(_context2, function (route) {
        return !1 !== route.showOnNavBar;
      })).call(_context, function (route) {
        return resolveNestedPropClassNames(route, callbackMap, classNameMap);
      });
    }, [callbackMap, classNameMap, routes]),
    visibleLeftSideRoutes = useMemo(function () {
      var _context3;
      return _filterInstanceProperty(_context3 = sideRoutes || []).call(_context3, function (route) {
        return !1 !== route.showOnNavBar;
      });
    }, [sideRoutes]),
    rightSideInitiallyCollapsed = (null == rightSideProps ? void 0 : rightSideProps.isInitiallyCollapsed) || isLowerThanDesktop,
    _useState = useState(rightSideInitiallyCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    rightSideCollapsed = _useState2[0],
    setRightSideCollapsed = _useState2[1],
    rightSideContext = useContext(RightSideBarContext);
  useEffect(function () {
    setRightSideCollapsed(rightSideInitiallyCollapsed);
  }, [rightSideInitiallyCollapsed]);
  var newRightSideContext = useMemo(function () {
      return null != rightSideContext && rightSideContext.collapse ? rightSideContext : _objectSpread(_objectSpread({}, rightSideContext), {}, {
        collapse: {
          isCollapsed: rightSideCollapsed,
          setIsCollapsed: setRightSideCollapsed
        }
      });
    }, [rightSideCollapsed, rightSideContext]),
    header = showHeader && React.createElement(AppFloorPlanHeader, {
      headerProps: headerProps,
      renderHeader: renderHeader,
      subHeaderProps: subHeaderProps,
      visibleLeftSideRoutes: visibleLeftSideRoutes,
      visibleRoutes: visibleRoutes,
      callbackMap: callbackMap,
      classNameMap: classNameMap,
      componentMap: componentMap
    }),
    _ref2 = subHeaderProps || {},
    subHeaderContextSwitcher = _ref2.contextSwitcher,
    renderSubHeaderContextSwitcher = _ref2.renderContextSwitcher,
    subHeader = showSubHeaderProp && Boolean(visibleRoutes.length > 0 || subHeaderContextSwitcher || renderSubHeaderContextSwitcher) && !isLowerThanDesktop && React.createElement(AppFloorPlanSubHeader, {
      subHeaderProps: subHeaderProps,
      visibleRoutes: visibleRoutes,
      callbackMap: callbackMap
    }),
    _ref3 = leftSideProps || {},
    leftSideContextSwitcher = _ref3.contextSwitcher,
    renderLeftContextSwitcher = _ref3.renderContextSwitcher,
    leftSide = showLeftSideProp && (visibleLeftSideRoutes.length > 0 || !!leftSideContextSwitcher || !!renderLeftContextSwitcher) && !isLowerThanDesktop && React.createElement(AppFloorPlanLeftSide, {
      leftSideProps: leftSideProps,
      sideRoutes: sideRoutes
    }),
    _ref4$sides = (rightSideProps || {}).sides,
    sides = void 0 === _ref4$sides ? [] : _ref4$sides,
    rightSide = showRightSideProp && sides && sides.length > 0 && React.createElement(AppFloorPlanRightSide, {
      rightSideProps: rightSideProps,
      isLowerThanDesktop: isLowerThanDesktop,
      componentMap: componentMap
    }),
    footer = showFooter && React.createElement(AppFloorPlanFooter, {
      footerProps: footerProps,
      callbackMap: callbackMap,
      classNameMap: classNameMap,
      componentMap: componentMap
    });
  return React.createElement(QuickViewProvider, null, React.createElement(RightSideBarContext.Provider, {
    value: newRightSideContext
  }, React.createElement(AppFloorPlanLayout, {
    className: className,
    scrollContent: scrollContent,
    header: header,
    subHeader: subHeader,
    leftSide: leftSide,
    rightSide: rightSide,
    footer: footer,
    contentLayout: contentLayout,
    contentClassName: contentClassName,
    contentAsSectionElement: contentAsSectionElement
  }, React.createElement(AppFloorPlanContent, {
    componentMap: componentMap,
    routes: routes,
    sideRoutes: sideRoutes,
    excludeScrollToTopRoutes: floorPlan.excludeScrollToTopRoutes
  }))));
};
var subHeaderProps = {
    className: PropTypes.string,
    contextSwitcher: contextSwitcherShape
  },
  rightSideProps = {
    isInitiallyCollapsed: PropTypes.bool,
    collapsible: PropTypes.bool,
    sides: PropTypes.arrayOf(sideContentShape.isRequired)
  },
  footerProps = {
    component: PropTypes.string,
    componentProps: PropTypes.shape({}),
    content: PropTypes.array
  },
  floorPlanProps = {
    showHeader: PropTypes.bool,
    showSubHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
    showLeftSide: PropTypes.bool,
    showRightSide: PropTypes.bool,
    routes: routesShape,
    sideRoutes: routesShape,
    renderHeader: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.string.isRequired]),
    header: PropTypes.shape({
      commonAvatarRoutes: PropTypes.array,
      helpPopoverItems: PropTypes.array
    }),
    subHeader: PropTypes.shape(subHeaderProps),
    rightSide: PropTypes.shape(rightSideProps),
    footer: PropTypes.shape(footerProps),
    scrollContent: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    contentLayout: PropTypes.oneOf(["canvas", "default", "center"]),
    leftSide: PropTypes.shape({
      contextSwitcher: contextSwitcherShape
    }),
    noContentPadding: PropTypes.bool,
    contentAsSectionElement: PropTypes.bool
  },
  routeMatchProps = {
    exact: PropTypes.bool,
    strict: PropTypes.bool,
    sensitive: PropTypes.bool,
    path: PropTypes.string
  },
  routeMatchShape = PropTypes.shape(routeMatchProps),
  floorPlanOverrideProps = _objectSpread(_objectSpread({}, floorPlanProps), {}, {
    matches: PropTypes.oneOfType([PropTypes.string, routeMatchShape, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, routeMatchShape]).isRequired)]).isRequired
  }),
  appFloorPlanPropTypes = {
    componentMap: PropTypes.shape({}),
    classNameMap: PropTypes.shape({}),
    callbackMap: PropTypes.shape({}),
    floorPlans: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(floorPlanProps), PropTypes.shape(floorPlanOverrideProps)]).isRequired)
  };
AppFloorPlan.propTypes = appFloorPlanPropTypes, AppFloorPlan.displayName = "AppFloorPlan", AppFloorPlan.__docgenInfo = {
  description: "Floorplan for the app, giving ability to use footer, header and nav out of the box",
  methods: [],
  displayName: "AppFloorPlan",
  props: {
    callbackMap: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve callback map"
    },
    classNameMap: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve class name map"
    },
    floorPlans: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "shape",
            value: {
              showHeader: {
                name: "bool",
                description: "Show/hide Header",
                required: !1
              },
              showSubHeader: {
                name: "bool",
                description: "Defines whether the sub navigation is shown or not",
                required: !1
              },
              showFooter: {
                name: "bool",
                description: "Show/hide footer",
                required: !1
              },
              showLeftSide: {
                name: "bool",
                description: "Show/hide left navigation",
                required: !1
              },
              showRightSide: {
                name: "bool",
                description: "Show/hide right panel",
                required: !1
              },
              routes: {
                name: "custom",
                raw: "routesShape",
                description: "Routing metadata object",
                required: !1
              },
              sideRoutes: {
                name: "custom",
                raw: "routesShape",
                description: "App routes to be shown in Left Side",
                required: !1
              },
              renderHeader: {
                name: "union",
                value: [{
                  name: "func"
                }, {
                  name: "string"
                }],
                description: "Render custom header",
                required: !1
              },
              header: {
                name: "custom",
                raw: "PropTypes.shape({\n    commonAvatarRoutes: PropTypes.array,\n    helpPopoverItems: PropTypes.array,\n}) as WeakValidationMap<FloorPlan>['header']",
                description: "Properties for Application Header component",
                required: !1
              },
              subHeader: {
                name: "shape",
                value: {
                  className: {
                    name: "string",
                    required: !1
                  },
                  contextSwitcher: {
                    name: "custom",
                    raw: "contextSwitcherShape",
                    required: !1
                  }
                },
                description: "Sub header config",
                required: !1
              },
              rightSide: {
                name: "shape",
                value: {
                  isInitiallyCollapsed: {
                    name: "bool",
                    required: !1
                  },
                  collapsible: {
                    name: "bool",
                    required: !1
                  },
                  sides: {
                    name: "arrayOf",
                    value: {
                      name: "custom",
                      raw: "sideContentShape.isRequired"
                    },
                    required: !1
                  }
                },
                description: "Right panel config",
                required: !1
              },
              footer: {
                name: "shape",
                value: {
                  component: {
                    name: "string",
                    required: !1
                  },
                  componentProps: {
                    name: "shape",
                    value: {},
                    required: !1
                  },
                  content: {
                    name: "array",
                    required: !1
                  }
                },
                description: "Children components config for Footer",
                required: !1
              },
              scrollContent: {
                name: "bool",
                description: "Make content scrollable",
                required: !1
              },
              className: {
                name: "string",
                description: "Additional class names for component.",
                required: !1
              },
              contentClassName: {
                name: "string",
                description: "Additional class name for main component.",
                required: !1
              },
              contentLayout: {
                name: "enum",
                value: [{
                  value: "'canvas'",
                  computed: !1
                }, {
                  value: "'default'",
                  computed: !1
                }, {
                  value: "'center'",
                  computed: !1
                }],
                description: "Layout type of main content",
                required: !1
              },
              leftSide: {
                name: "shape",
                value: {
                  contextSwitcher: {
                    name: "custom",
                    raw: "contextSwitcherShape",
                    description: "Context switcher object",
                    required: !1
                  }
                },
                description: "Props passed to SideNavigation",
                required: !1
              },
              noContentPadding: {
                name: "bool",
                description: "Remove padding of page content",
                required: !1
              },
              contentAsSectionElement: {
                name: "bool",
                description: "If true content is rendered within <section> html semantic element otherwise <main> is used\nShould be used when page contains multiple floorplans as only one element with 'main' role is recommended",
                required: !1
              }
            }
          }, {
            name: "shape",
            value: {
              matches: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "custom",
                  raw: "routeMatchShape"
                }, {
                  name: "arrayOf",
                  value: {
                    name: "union",
                    value: [{
                      name: "string"
                    }, {
                      name: "custom",
                      raw: "routeMatchShape"
                    }]
                  }
                }],
                description: "The props to match against the current location. If match, the configuration override will be applied",
                required: !0
              }
            }
          }]
        }
      },
      required: !1,
      description: "Array with the default floorplan and floorplan overrides"
    },
    componentMap: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve component map"
    }
  }
};
export default AppFloorPlan;
AppFloorPlan.__docgenInfo = {
  componentName: "AppFloorPlan",
  packageName: "@jutro/floorplan",
  description: "Floorplan for the app, giving ability to use footer, header and nav out of the box",
  displayName: "AppFloorPlan",
  methods: [],
  actualName: "AppFloorPlan",
  props: {
    componentMap: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve component map"
    },
    classNameMap: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve class name map",
      defaultValue: {
        value: "{}",
        computed: !1
      }
    },
    callbackMap: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Resolve callback map",
      defaultValue: {
        value: "{}",
        computed: !1
      }
    },
    floorPlans: {
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "shape",
            value: {
              showHeader: {
                name: "bool",
                description: "Show/hide Header",
                required: !1
              },
              showSubHeader: {
                name: "bool",
                description: "Defines whether the sub navigation is shown or not",
                required: !1
              },
              showFooter: {
                name: "bool",
                description: "Show/hide footer",
                required: !1
              },
              showLeftSide: {
                name: "bool",
                description: "Show/hide left navigation",
                required: !1
              },
              showRightSide: {
                name: "bool",
                description: "Show/hide right panel",
                required: !1
              },
              routes: {
                name: "arrayOf",
                description: "Routing metadata object",
                required: !1,
                value: {
                  name: "custom",
                  raw: "routeShape"
                }
              },
              sideRoutes: {
                name: "arrayOf",
                description: "App routes to be shown in Left Side",
                required: !1,
                value: {
                  name: "custom",
                  raw: "routeShape"
                }
              },
              renderHeader: {
                name: "union",
                value: [{
                  name: "func"
                }, {
                  name: "string"
                }],
                description: "Render custom header",
                required: !1
              },
              header: {
                name: "shape",
                value: {
                  commonAvatarRoutes: {
                    name: "array",
                    required: !1
                  },
                  helpPopoverItems: {
                    name: "array",
                    required: !1
                  }
                },
                description: "Properties for Application Header component",
                required: !1
              },
              subHeader: {
                name: "shape",
                value: {
                  className: {
                    name: "string",
                    required: !1
                  },
                  contextSwitcher: {
                    name: "shape",
                    required: !1,
                    value: {
                      defaultLabel: {
                        name: "custom",
                        raw: "intlMessageShape",
                        description: "Default button label when no context is active",
                        required: !1
                      },
                      values: {
                        name: "arrayOf",
                        value: {
                          name: "custom",
                          raw: "contextShape.isRequired"
                        },
                        description: "Array of values for the contexts",
                        required: !0
                      }
                    }
                  }
                },
                description: "Sub header config",
                required: !1
              },
              rightSide: {
                name: "shape",
                value: {
                  isInitiallyCollapsed: {
                    name: "bool",
                    required: !1
                  },
                  collapsible: {
                    name: "bool",
                    required: !1
                  },
                  sides: {
                    name: "arrayOf",
                    value: {
                      name: "shape",
                      value: {
                        id: {
                          name: "string",
                          description: "Id of side content trigger button",
                          required: !1
                        },
                        label: {
                          name: "custom",
                          raw: "intlMessageShape.isRequired",
                          description: "Label describing the content used for accessibility",
                          required: !0
                        },
                        icon: {
                          name: "string",
                          description: "Icon that will represent the content on the icon bar",
                          required: !1
                        },
                        component: {
                          name: "elementType",
                          description: "Component to render as content",
                          required: !0
                        },
                        componentProps: {
                          name: "shape",
                          value: {},
                          description: "Component props",
                          required: !1
                        }
                      }
                    },
                    required: !1
                  }
                },
                description: "Right panel config",
                required: !1
              },
              footer: {
                name: "shape",
                value: {
                  component: {
                    name: "string",
                    required: !1
                  },
                  componentProps: {
                    name: "shape",
                    value: {},
                    required: !1
                  },
                  content: {
                    name: "array",
                    required: !1
                  }
                },
                description: "Children components config for Footer",
                required: !1
              },
              scrollContent: {
                name: "bool",
                description: "Make content scrollable",
                required: !1
              },
              className: {
                name: "string",
                description: "Additional class names for component.",
                required: !1
              },
              contentClassName: {
                name: "string",
                description: "Additional class name for main component.",
                required: !1
              },
              contentLayout: {
                name: "enum",
                value: [{
                  value: "'canvas'",
                  computed: !1
                }, {
                  value: "'default'",
                  computed: !1
                }, {
                  value: "'center'",
                  computed: !1
                }],
                description: "Layout type of main content",
                required: !1
              },
              leftSide: {
                name: "shape",
                value: {
                  contextSwitcher: {
                    name: "shape",
                    description: "Context switcher object",
                    required: !1,
                    value: {
                      defaultLabel: {
                        name: "custom",
                        raw: "intlMessageShape",
                        description: "Default button label when no context is active",
                        required: !1
                      },
                      values: {
                        name: "arrayOf",
                        value: {
                          name: "custom",
                          raw: "contextShape.isRequired"
                        },
                        description: "Array of values for the contexts",
                        required: !0
                      }
                    }
                  }
                },
                description: "Props passed to SideNavigation",
                required: !1
              },
              noContentPadding: {
                name: "bool",
                description: "Remove padding of page content",
                required: !1
              },
              contentAsSectionElement: {
                name: "bool",
                description: "If true content is rendered within <section> html semantic element otherwise <main> is used\nShould be used when page contains multiple floorplans as only one element with 'main' role is recommended",
                required: !1
              }
            }
          }, {
            name: "shape",
            value: {
              matches: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "custom",
                  raw: "routeMatchShape"
                }, {
                  name: "arrayOf",
                  value: {
                    name: "union",
                    value: [{
                      name: "string"
                    }, {
                      name: "custom",
                      raw: "routeMatchShape"
                    }]
                  }
                }],
                description: "The props to match against the current location. If match, the configuration override will be applied",
                required: !0
              }
            }
          }]
        }
      },
      required: !1,
      description: "Array with the default floorplan and floorplan overrides",
      defaultValue: {
        value: "[]",
        computed: !1
      }
    }
  }
};